import classNames from 'classnames';
import React, { useCallback } from 'react';

import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

import styles from './switch.module.css';

interface SwitchProps<T> {
  value: T;
  on: boolean;
  onClick: (value: T, on: boolean) => void;
  disabled?: boolean;
  stopPropagation?: boolean;
  paused?: boolean;
  color?: string;
  loading?: boolean;
}

const Switch = <T,>({
  value,
  on,
  onClick,
  disabled = false,
  stopPropagation = false,
  paused = false,
  color = getThemeColorCSSVariable(),
  loading,
}: SwitchProps<T>) => {
  const memoizedClick = useCallback(
    (e?: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled) return;
      if (stopPropagation) {
        e?.stopPropagation();
      }
      onClick(value, !on);
    },
    [disabled, on, onClick, stopPropagation, value]
  );

  return (
    <button
      onClick={memoizedClick}
      className={classNames('clear-button', styles['switch'], {
        [styles['on']]: on,
        [styles['isDisabled']]: disabled,
        [styles['paused']]: paused,
        [styles['loading']]: loading,
      })}
      style={{ '--switch-on-color': color } as React.CSSProperties}
      disabled={paused || disabled}
      data-on={on}
    >
      <div className={styles['gutter']}>
        <div className={styles['thumb']} />
      </div>
    </button>
  );
};

export default Switch;
